import { createEvent } from "library/local-events/index.mjs"

// Raised (instance-scoped) by the server when a background scenario → draft-regime promotion
// finishes, allowing the Optimiser UI to notify the user and offer to open the new draft regime.
// Payload: { scenarioId, regimeId, regimeName, tasksEvaluated, tasksChanged, excludedCount,
//            modifiedCount, auditsWritten, auditWriteFailures, error? }
//
// .mjs so the server worker can import it; client .js files can import it too.
export const ScenarioPromotionComplete = createEvent("ScenarioPromotionComplete")

// Raised (instance-scoped) by the worker as the promotion progresses through its phases, so the
// persistent progress snackbar can show what is happening. Payload: { scenarioId, message }.
export const ScenarioPromotionProgress = createEvent("ScenarioPromotionProgress")
